"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preAdjudicationVerificationSchema = void 0;
exports.preAdjudicationVerificationSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'chargeCodeCheckIndicator',
        'eddFemsiCheckIndicator',
        'primaryRiskTableCheckIndicator',
        'rffiCheckIndicator',
    ],
    properties: {
        chargeCodeCheckIndicator: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483647,
            errorMessage: 'Should be an integer',
        },
        eddFemsiCheckIndicator: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483647,
            errorMessage: 'Should be an integer',
        },
        primaryRiskTableCheckIndicator: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483647,
            errorMessage: 'Should be an integer',
        },
        rffiCheckIndicator: {
            type: 'integer',
            maximum: 2147483647,
            minimum: -2147483647,
            errorMessage: 'Should be an integer',
        },
    },
};
